import React, { useEffect, useState } from 'react';
import './ProgressBar.scss';
export default ({ activePage, totalPages, onHandleClickOnPhase }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [slides, setSlides] = useState(null);
  const phaseLimits = [6, 8, 14, 19];

  useEffect(() => { setCurrentPage(activePage) }, [activePage]);
  useEffect(() => {
    let tSlides = [];
    for (let i=0; i<totalPages; i++) {
      tSlides.push({});
    }
    setSlides(tSlides);
  }, [totalPages]);
  
  const handleClick = (index) => onHandleClickOnPhase(index)
  return (
    <div className={`progress-bar ${currentPage === 0 ? 'progress-bar--hide' : ''} `}>
          <div className="nav-segment phase-segment" onClick={() => handleClick(0)}>
            <span></span>
          </div>
          {slides && slides.map((slide, i) => {
            let isPhase = false;
            let isDark = false;
            let currIndex;
            phaseLimits.forEach((limit, j) => {
              if (phaseLimits[j] === i) {
                isPhase = true;
                currIndex = j;
              }
            })
            if (i <= activePage) isDark = true;
            return (
              <div onClick={() => handleClick(phaseLimits[currIndex])} className={`nav-segment ${isPhase ? 'phase-segment' : ''} ${isDark ? 'dark' : ''}`}><span></span></div>
            )
          })}
        <div className="nav-segment phase-segment" onClick={() => handleClick(24)}>
          <span></span>
        </div>
    </div>
  )
}